import React from "react"
import { Route } from "react-router-dom"

const Logout = () => {
  return <div>logout</div>
}

export default Logout
